/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { GetInitiativeLibrary } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import SkeletonLoder from "../../common/skeletonLoder";
import { NoData } from "../styles";
import {InitiativesWrap, InitiativeCard} from '../../HealthDataManagement/styles'
import {RecognitionEyeIconNew, RecognitionLaunchIcon} from '../../../utils/icons'
import DetailPopup from '../../HealthDataManagement/initiativesInfo';

class libraryInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: this.props.companyInfo.id,
      launchDate: new Date(),
      year: new Date().getFullYear(),
      pointsArrow: false,
      loading:false,
      showDetailPopup: false,
      detailInitiative: null,
      libraryInitiatives:[]
    };
  }

  componentDidMount() {
    this.getLibraryInitiatives(this.props.selectedYearInfo);
  }

  hideShowPopup = () => {
    this.setState({ showDetailPopup: false, detailInitiative:null });
  }

  showPopup = (data) => {
    this.setState({ showDetailPopup: true, detailInitiative:data })
  }

  getLibraryInitiatives = async () => {
    this.setState({ loading: true });
    let apiUrl = GetInitiativeLibrary + "/" + this.state.companyId;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        this.setState({ libraryInitiatives: res?.data,loading: false });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  chunkArray = (arr, size) => (
    arr.reduce((acc, _, i) => 
      i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc
    , [])
  );

  redirectToCompanyInitiative = (obj) => {
    const { history } = this.props;
    history.push({pathname: "/company/company-initiative", state: {id: obj?.id, initiative_name: obj?.initiative_name,initiativeDetails:obj}});
  };

  libraryInitiatives = () =>{
    const { libraryInitiatives } = this.state;
    const initiativeChunks = this.chunkArray(libraryInitiatives, 3);
    return(
      <InitiativesWrap>
        <div className="details">
          {initiativeChunks.map((chunk, chunkIndex) => (
            <React.Fragment key={chunkIndex}>
              <div className="initiative-row">
                {chunk.map((initiative) => (
                  <div className="initiative-card" key={initiative.id}>
                    <InitiativeCard background={initiative?.color}>
                      <div className="icon">
                        <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="initiative" />
                      </div>
                      <div className="initiative-title">{initiative.initiative_name}</div>
                      <div className="end-container"  onClick={!initiative?.re_launch_status?() => this.setState({showDetailPopup:true,detailInitiative:initiative}):() => this.redirectToCompanyInitiative(initiative)}>
                        {initiative?.re_launch_status?RecognitionLaunchIcon(): RecognitionEyeIconNew()}
                      </div>
                    </InitiativeCard>
                  </div>
                ))}
              </div>
              {/* Border after every row of 3 cards */}
              {chunkIndex+1!==initiativeChunks?.length&&<div className="border-card"/>}
            </React.Fragment>
          ))}
        </div>
      </InitiativesWrap>
    )
  }

  render() {
    const { libraryInitiatives,loading, showDetailPopup , detailInitiative } = this.state;

    if (loading) {
      return <div style={{width:'385px'}}> 
        <SkeletonLoder width={"1248px"} height={"500px"}/>
      </div>;
    }

    return (<>
      {libraryInitiatives?.length > 0 ? this.libraryInitiatives():<NoData>No Data Found!</NoData>}
      {showDetailPopup && <DetailPopup showModal={showDetailPopup} detailInitiative={detailInitiative} onClose={this.hideShowPopup} companyId={this.props.companyInfo.id}/>}
    </>
    );
  }
}

libraryInitiative.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.any,
  companyInfo: PropTypes.any,
  selectedYearInfo:PropTypes.number,
};

export default connect(
  null,
  null
)(libraryInitiative);
